//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    homeTiles: {
      type: Array,
      required: true
    },
    homeFeatured: {
      type: Object,
      required: true
    }
  },
  computed: {
    topTiles () {
      return this.homeTiles.slice(0, 4)
    },
    bottomTiles () {
      return this.homeTiles.slice(4)
    }
  }
}

